<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <button mat-icon-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0 popup-wrapper">
    <div class="popup-actions">
      <button mat-raised-button color="primary" (click)="$event.preventDefault(); popUpContato({}, true)">
        <mat-icon>person_add</mat-icon>
        Adicionar Contato
      </button>
    </div>

    <ng-container *ngIf="layoutConf?.isMobile; else desktopContatoTable">
      <div class="mobile-cards-wrap" *ngIf="contatos?.length; else emptyContatoList">
        <mat-card class="mobile-card" *ngFor="let row of contatos; let i = index">
          <div class="mobile-card-header">
            <div class="mobile-card-title">#{{ i + 1 }} - {{ row?.nome || 'Contato sem nome' }}</div>
            <div class="mobile-card-actions">
              <button mat-icon-button color="primary" matTooltip="Editar"
                      (click)="$event.preventDefault(); popUpContato(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Excluir"
                      (click)="$event.preventDefault(); deleteContato(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div class="mobile-card-grid">
            <div><span>Cargo</span><strong>{{ row?.cargo || '-' }}</strong></div>
            <div><span>Telefone</span><strong>{{ row?.telefone || '-' }}</strong></div>
          </div>

          <div class="mobile-card-line" *ngIf="row?.email">
            <span>E-mail</span>
            <strong>{{ row?.email }}</strong>
          </div>

          <div class="mobile-card-line" *ngIf="row?.obsTelefone">
            <span>Observação</span>
            <strong>{{ row?.obsTelefone }}</strong>
          </div>
        </mat-card>
      </div>

      <mat-paginator
        class="mobile-paginator"
        #paginatorContato
        [length]="lengthContato"
        [showFirstLastButtons]="true"
        [pageSize]="pageSizeContato"
        [pageSizeOptions]="pageSizeOptionsContato"
        (page)="pageEventContato = setPageSizeOptionsContato($event)">
      </mat-paginator>
    </ng-container>

    <ng-template #desktopContatoTable>
      <ngx-datatable
        class="material ml-0 mr-0"
        [rows]="contatos"
        [headerHeight]="50"
        [footerHeight]="50"
        [scrollbarH]="true"
        [messages]="{emptyMessage:'Nenhum Contato encontrado'}"
        [limit]="pageSizeContato"
        [columnMode]="'force'"
        [rowHeight]="50">
        <ngx-datatable-column name="#" [width]="25" [canAutoResize]="false">
          <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <strong>{{ rowIndex + 1 }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Opções" [width]="100" [canAutoResize]="false">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                    (click)="$event.preventDefault(); popUpContato(row)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button mat-sm-button color="warn"
                    (click)="$event.preventDefault(); deleteContato(row)">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Nome" prop="nome" [width]="220"></ngx-datatable-column>
        <ngx-datatable-column name="Cargo" prop="cargo" [width]="150"></ngx-datatable-column>
        <ngx-datatable-column name="Telefone" prop="telefone" [width]="150"></ngx-datatable-column>
        <ngx-datatable-column name="E-mail" prop="email" [width]="220"></ngx-datatable-column>
        <ngx-datatable-column name="Observação" prop="obsTelefone" [width]="180"></ngx-datatable-column>
      </ngx-datatable>

      <mat-paginator
        #paginatorContato
        [length]="lengthContato"
        [showFirstLastButtons]="true"
        [pageSize]="pageSizeContato"
        [pageSizeOptions]="pageSizeOptionsContato"
        (page)="pageEventContato = setPageSizeOptionsContato($event)">
      </mat-paginator>
    </ng-template>

    <ng-template #emptyContatoList>
      <div class="empty-list">Nenhum contato cadastrado.</div>
    </ng-template>
  </mat-card>
</div>
